import { MailParams } from '@dadohr/shared/domainTypes/mail';
import { callFirebaseFunction } from '../firebaseFunctions';

export const sendSmsPreview = (
  params: MailParams,
  phoneNumber: string,
  orgId: string
) => {
  console.log('SMS Preview params', params);
  return callFirebaseFunction('integrations_twilio-sendSMSPreview', {
    params,
    to: phoneNumber,
    orgId
  });
};
